import Defaults from '@/models/Simulation/SimulationFormDefault'
import {
  DeliveryDevices,
  DeliveryInventories,
} from '@/models/CampaignOperation/Constants'

const defaults = Defaults.advancedSetting

class DemographicSetting {
  constructor(sex, marriage, age, prefecture) {
    this.sex = sex
    this.marriage = marriage
    this.age = age
    this.prefecture = prefecture
  }
  removeSex() {
    this.sex = null
    return this
  }

  removeMarriage() {
    this.marriage = null
    return this
  }

  removeAge(index) {
    this.age.splice(index, 1)
    if (this.age.length === 0) {
      this.age = null
    }
    return this
  }
}

export class SimulationFormAdvanced {
  constructor(items = {}) {
    const {
      useAdvancedSetting = defaults.useAdvancedSetting,
      advancedSetting = {},
    } = items
    const {
      deliveryDevices = defaults.deliveryDevices,
      deliveryInventories = defaults.deliveryInventories,
      onlyJapaneseDevice = defaults.onlyJapaneseDevice,
      deliveryTimeSchedules = defaults.deliveryTimeSchedules,
      sex = defaults.sex,
      marriage = defaults.marriage,
      age = defaults.age,
      prefecture = defaults.prefecture,
    } = advancedSetting
    this.useAdvancedSetting = useAdvancedSetting
    this.deliveryDevices = deliveryDevices
    this.deliveryInventories = deliveryInventories
    this.onlyJapaneseDevice = onlyJapaneseDevice
    this.deliveryTimeSchedules = deliveryTimeSchedules
    this.demographicSetting = new DemographicSetting(
      sex,
      marriage,
      age,
      prefecture,
    )
  }

  get isDeviceEmpty() {
    return this.deliveryDevices.length === 0
  }

  get isInventoryEmpty() {
    return this.deliveryInventories.length === 0
  }

  // タブレットまたはスマートフォンを選択しているか
  get isSelectedMobileDevice() {
    return this.deliveryDevices.some(
      device =>
        device === DeliveryDevices.PHONE || device === DeliveryDevices.TABLET,
    )
  }

  // Webブラウザを選択しているか
  get isSelectedWebInventory() {
    return this.deliveryInventories.some(
      inventory =>
        inventory === DeliveryInventories.WEB ||
        inventory === DeliveryInventories.MOBILE_WEB,
    )
  }

  // PC選択時にWEBブラウザが選択されてない
  get isIncorrectInventoryCombinationWithPC() {
    if (!this.deliveryDevices.includes(DeliveryDevices.PC)) {
      return false
    }
    return !this.deliveryInventories.includes(DeliveryInventories.WEB)
  }

  // タブレットまたはスマートフォン選択時に配信面が選択されていない
  get isIncorrectInventoryCombinationWithMobile() {
    if (!this.isSelectedMobileDevice) {
      return false
    }
    return this.isInventoryEmpty
  }

  // Webブラウザ選択時にデバイスが選択されていない
  get isIncorrectDeviceCombinationWithWeb() {
    if (!this.isSelectedWebInventory) {
      return false
    }
    return this.isDeviceEmpty
  }

  // アプリ選択時にタブレットまたはスマートフォンが選択されていない
  get isIncorrectDeviceCombinationWithApp() {
    if (!this.deliveryInventories.includes(DeliveryInventories.MOBILE_APP)) {
      return false
    }
    return !this.deliveryDevices.some(
      device =>
        device === DeliveryDevices.TABLET || device === DeliveryDevices.PHONE,
    )
  }

  get isSimulatable() {
    return (
      !this.isDeviceEmpty &&
      !this.isInventoryEmpty &&
      !this.isIncorrectInventoryCombinationWithPC &&
      !this.isIncorrectInventoryCombinationWithMobile &&
      !this.isIncorrectDeviceCombinationWithWeb &&
      !this.isIncorrectDeviceCombinationWithApp
    )
  }

  initializeAdvancedSetting() {
    this.deliveryDevices = defaults.deliveryDevices
    this.deliveryInventories = defaults.deliveryInventories
    this.onlyJapaneseDevice = defaults.onlyJapaneseDevice
    this.weeklyDeliverySchedule = defaults.weeklyDeliverySchedule
    this.demographicSetting = new DemographicSetting(
      defaults.sex,
      defaults.marriage,
      defaults.age,
      defaults.prefecture,
    )
  }

  changeUseAdvancedSetting(useAdvancedSetting) {
    if (!useAdvancedSetting) {
      this.initializeAdvancedSetting()
    }
    this.useAdvancedSetting = useAdvancedSetting
  }
}
